import {Footer, Login} from "../../components";
import React from "react";

export default function LoginPage() {
    return (
        <div>
            <Login/>
            <Footer/>
        </div>
    )
}
